import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import RemoveAccountInAppRequest from './RemoveAccountInAppRequest';

loadDOMComponent({
	selector: 'react-remove-account-in-app',
	callback: ({ container, context }: any) => {
		const userId: string = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<RemoveAccountInAppRequest userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
